export default "__VITE_ASSET__BJ2TnVg5__"